
import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter } from "vuex-class";
import { apiLogout } from "@/api/app";

@Component
export default class Header extends Vue {
  @State("user") user: any;
  @Getter("permission") permission: any;
  WorkorderUnreadCount: number = 0;
  get activePath() {
    let activePath = "";
    const meta = this.$route.meta;
    for (let i = 0; i < this.permission?.routes.length; i++) {
      const element = this.permission?.routes[i];
      if (element.path === meta?.parentPath) {
        activePath = element.path;
        break;
      } else {
        element.children.forEach((child: any) => {
          if (child.path === meta?.parentPath) {
            activePath = child.meta.parentPath;
          }
        });
      }
    }
    return activePath;
  }

  get menuList() {
    return this.permission?.routes;
  }

  get userInfo() {
    return this.user.userInfo;
  }

  get logo() {
    return this.$store.getters.config.logo;
  }
  handleCommand(command: string) {
    switch (command) {
      case "logout":
        this.logout();
    }
  }
  handleClickMenu(item: any) {
    const path = "/" + item.meta.activeMenu;
    this.$router.push(path);
  }
  logout() {
    apiLogout().then(() => {
      this.$store.commit("setUserInfo", {});
      this.$store.commit("setPermission", {});
      this.$router.push("/account/login");
    });
  }
  getUnreadCount() {
    // apiWorkorderUnread().then((res) => {
    //   console.log("🚀 ~ Header ~ getUnreadCount ~ res:", res)
    //   this.WorkorderUnreadCount = res.count;
    // });
  }

  mounted() {
    this.activePath;
    this.getUnreadCount();
  }
}
